/**
 * Invoca la Edge Function send-push (campana + push según preferencias).
 * Auth: sesión Supabase del usuario (sin secret en el cliente).
 */

import { supabase } from '../supabase';
import type { NotificationPrefEventType } from './notificationPreferenceCatalog';

export type PushEventType = NotificationPrefEventType;

export type SendPushPayload = {
  empresa_id: string;
  event_type: PushEventType;
  title: string;
  body: string;
  tipo?: string;
  usuario_id?: string | null;
  notify_empresa_admins?: boolean;
  data?: {
    deep_link?: string;
    factura_id?: string;
    cliente_id?: string;
  };
};

export async function invokeSendPush(payload: SendPushPayload): Promise<{ data: unknown; error: Error | null }> {
  try {
    const { data, error } = await supabase.functions.invoke('send-push', { body: payload });
    if (error) {
      console.warn('[invokeSendPush]', error.message);
      return { data: null, error: error as Error };
    }
    return { data, error: null };
  } catch (e) {
    const err = e instanceof Error ? e : new Error(String(e));
    console.warn('[invokeSendPush]', err.message);
    return { data: null, error: err };
  }
}
